import { create } from "zustand";

const useUserDashboard = create((set) => ({
  activeTab: 'booking',

  setActiveTab: (tab) => {
    set({ activeTab: tab });
  },

  resetTab: () => {
    set({ activeTab: 'booking' });
  },
}));

export default useUserDashboard; 